// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"scoring_wrapper__Fw8Gi"};